(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-plan"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get("best-plan")) {
  /**
   * BestPlan Component
   *
   */

  /**
   * Formats a YYYY-MM-DD date string into ordinal format: "29th Apr 2026"
   * @param {string} dateStr - Date in YYYY-MM-DD format
   * @returns {string} Formatted date string
   */
  function formatDateOrdinal(dateStr) {
    if (!dateStr) return "";
    const date = new Date(dateStr + "T00:00:00");
    if (isNaN(date.getTime())) return dateStr;

    const day = date.getDate();
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    const suffix = (d) => {
      if (d >= 11 && d <= 13) return "th";
      switch (d % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };

    return `${day}${suffix(day)} ${month} ${year}`;
  }

  const CHECKOUT_BTN_SELECTOR = ".best-plan__checkout-btn";

  class BestPlan extends HTMLElement {
    /** @type {HTMLElement | null} */
    #summary = null;

    /** @type {HTMLElement | null} */
    #save = null;

    /** @type {HTMLSelectElement | null} */
    #countrySelect = null;

    /** @type {HTMLElement | null} */
    #departureCalendar = null;

    /** @type {HTMLElement | null} */
    #arrivalCalendar = null;

    /** @type {HTMLButtonElement | null} */
    #checkoutBtn = null;

    /** @type {HTMLFormElement | null} */
    #form = null;

    /** @type {HTMLElement | null} */
    #errorMessage = null;

    /**
     * Initializes the component, selects required elements, and sets up state.
     */
    #init = () => {
      this.#form = this.querySelector(".best-plan__content");
      this.#summary = this.querySelector('[data-component="summary"]');
      this.#save = this.querySelector('[data-component="save"]');
      this.#countrySelect = this.querySelector(
        '[data-component="country-select"]',
      );
      this.#arrivalCalendar = this.querySelector(
        '[data-component="arrival-calendar"]',
      );
      this.#departureCalendar = this.querySelector(
        '[data-component="departure-calendar"]',
      );
      this.#errorMessage = this.querySelector(
        '[data-component="error-message"]',
      );
      this.#checkoutBtn = this.querySelector(CHECKOUT_BTN_SELECTOR);
    };

    /**
     * Attaches global and component-level event listeners.
     */
    #attachEventListeners = () => {
      if (this.#form) {
        this.#form.addEventListener("submit", this.#handleSubmit);
      }
      if (this.#checkoutBtn) {
        this.#checkoutBtn.addEventListener("click", this.#handleCheckout);
      }

      // Sync calendar date constraints
      const arrivalInput = this.#arrivalCalendar?.querySelector('[data-component="date-input"]');
      const departureInput = this.#departureCalendar?.querySelector('[data-component="date-input"]');

      if (arrivalInput) {
        arrivalInput.addEventListener("change", this.#handleArrivalChange);
      }
      if (departureInput) {
        departureInput.addEventListener("change", this.#handleDepartureChange);
      }
    };

    /**
     * Updates the departure calendar's min date when arrival changes.
     */
    #handleArrivalChange = (e) => {
      if (this.#departureCalendar) {
        if (e.target.value) {
          this.#departureCalendar.setAttribute("min", e.target.value);
        } else {
          this.#departureCalendar.removeAttribute("min");
        }
      }
    };

    /**
     * Updates the arrival calendar's max attribute when departure changes.
     */
    #handleDepartureChange = (e) => {
      if (this.#arrivalCalendar) {
        if (e.target.value) {
          this.#arrivalCalendar.setAttribute("max", e.target.value);
        } else {
          this.#arrivalCalendar.removeAttribute("max");
        }
      }
    };

    /**
     * Helper to show error messages gracefully.
     * @param {string} msg
     */
    #showError = (msg) => {
      if (this.#errorMessage) {
        this.#errorMessage.textContent = msg;
        // Optionally add an 'active' or 'visible' class if you have one in CSS
        this.#errorMessage.style.display = "block";
      }
    };

    /**
     * Clears any existing error messages.
     */
    #clearError = () => {
      if (this.#errorMessage) {
        this.#errorMessage.textContent = "";
        this.#errorMessage.style.display = "none";
      }
    };

    /**
     * Handles the form submission to find the best plan variant.
     * @param {Event} e
     */
    #handleSubmit = (e) => {
      e.preventDefault();
      this.#clearError();

      const country = this.#countrySelect?.value;
      const arrivalInput = /** @type {HTMLInputElement | null} */ (
        this.#arrivalCalendar?.querySelector('[data-component="date-input"]')
      );
      const departureInput = /** @type {HTMLInputElement | null} */ (
        this.#departureCalendar?.querySelector('[data-component="date-input"]')
      );

      const arrival = arrivalInput?.value;
      const departure = departureInput?.value;

      if (!country || !arrival || !departure) {
        this.#showError(
          "Please fill in all inputs (Country, Arrival date, and Departure date).",
        );
        return;
      }

      // Validate against 'min' attribute if present
      const minArrival = arrivalInput?.min;
      if (minArrival && arrival < minArrival) {
        this.#showError("Arrival date cannot be in the past.");
        return;
      }

      const minDeparture = departureInput?.min;
      if (minDeparture && departure < minDeparture) {
        this.#showError("Departure date cannot be in the past.");
        return;
      }

      const arrivalDate = new Date(arrival + "T00:00:00");
      const departureDate = new Date(departure + "T00:00:00");

      if (departureDate < arrivalDate) {
        this.#showError("Departure date cannot be earlier than arrival date.");
        return;
      }

      // Calculate the difference in inclusive days
      const diffTime = Math.abs(
        departureDate.getTime() - arrivalDate.getTime(),
      );
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

      const variants = Array.from(this.querySelectorAll(".card-plan-variant"));

      /** @type {any} */
      let bestMatch = null;

      variants.forEach((variant) => {
        // Clear active classes
        variant.classList.remove("active");
        const bestChoice = variant.querySelector(
          '[data-component="best-choice"]',
        );
        if (bestChoice) bestChoice.textContent = "";

        const min = parseInt(
          /** @type {any} */ (variant).dataset.minDiapazon || "",
          10,
        );
        const max = parseInt(
          /** @type {any} */ (variant).dataset.maxDiapazon || "",
          10,
        );

        if (!isNaN(min) && !isNaN(max)) {
          if (diffDays >= min && diffDays <= max) {
            bestMatch = variant;
          }
        } else if (!isNaN(min) && isNaN(max)) {
          // If there is a min but no max, it captures everything above
          if (diffDays >= min) {
            bestMatch = variant;
          }
        }
      });

      if (bestMatch) {
        bestMatch.classList.add("active");

        // Highlight logic
        const daysLabelTemplate = this.dataset.daysLabel || "";
        const updatedLabel = daysLabelTemplate.replace("Y;", diffDays.toString());

        const bestMatchChoice = bestMatch.querySelector(
          '[data-component="best-choice"]',
        );

        if (bestMatchChoice) {
          bestMatchChoice.textContent = updatedLabel;
        }

        // Show the summary section
        if (this.#summary) {
          this.#summary.classList.add("visible");
        }

        // Render save value if the user wants it
        if (this.#save && bestMatch.dataset.save) {
          this.#save.innerHTML = bestMatch.dataset.save;
        }

        bestMatch.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        this.#showError(`No suitable plan found for a ${diffDays}-day trip.`);
      }
    };

    /**
     * Handles the checkout button click to add the active variant to cart with attributes.
     * @param {Event} e
     */
    #handleCheckout = async (e) => {
      e.preventDefault();
      this.#clearError();

      const activeVariant = /** @type {HTMLElement | null} */ (
        this.querySelector(".card-plan-variant.active")
      );
      if (!activeVariant) {
        this.#showError("Please find your plan first by submitting the form.");
        return;
      }

      const variantId = activeVariant.dataset.variantId;
      if (!variantId) return;

      const countrySelect = this.#countrySelect;
      const country =
        countrySelect?.options[countrySelect.selectedIndex]?.text || "";

      const arrival =
        /** @type {HTMLInputElement | null} */ (
          this.#arrivalCalendar?.querySelector('[data-component="date-input"]')
        )?.value || "";
      const departure =
        /** @type {HTMLInputElement | null} */ (
          this.#departureCalendar?.querySelector(
            '[data-component="date-input"]',
          )
        )?.value || "";

      if (this.#checkoutBtn) {
        this.#checkoutBtn.classList.add("loading");
        this.#checkoutBtn.disabled = true;
      }

      try {
        await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            attributes: {
              Country: country,
              "Arrival Date": formatDateOrdinal(arrival),
              "Preferred Arrival Date": formatDateOrdinal(arrival),
              "Departure Date": formatDateOrdinal(departure),
            }
          }),
        }).then((res) => {
          if (!res.ok) throw new Error("Could not update cart attributes");
          return res.json();
        });

        await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],
          }),
        }).then((res) => {
          if (!res.ok) throw new Error("Could not add to cart");
          return res.json();
        });

        setTimeout(() => {
          window.location.href = "/checkout";
        }, 500);

      } catch (error) {
        console.error("Error adding to cart:", error);
        if (this.#checkoutBtn) {
          this.#checkoutBtn.classList.remove("loading");
          this.#checkoutBtn.disabled = false;
        }
        this.#showError("Failed to add plan to cart. Please try again.");
      }
    };

    connectedCallback() {
      this.#init();
      this.#attachEventListeners();
    }

    disconnectedCallback() {
      if (this.#form) {
        this.#form.removeEventListener("submit", this.#handleSubmit);
      }
      if (this.#checkoutBtn) {
        this.#checkoutBtn.removeEventListener("click", this.#handleCheckout);
      }
    }
  }

  customElements.define("best-plan", BestPlan);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collage-images"] && !Shopify.designMode) return;
  try {
    
/**
 * Scroll Animated Section Component
 * 
 * Usage:
 * 1. Wrap your content in <scroll-animated-section data-parallax="true">
 * 2. Add class 'animate-scroll' to child elements that should scale/fade.
 * 3. Use CSS: transform: scale(var(--scroll-scale, 1)); opacity: var(--scroll-opacity, 1);
 */
if (!customElements.get("scroll-animated-section")) {
  class ScrollAnimatedSection extends HTMLElement {
    #active = false;
    #rafPending = false;
    #intersectionObserver = null;

    connectedCallback() {
      // Look for data-parallax or a simple active flag
      this.#active = this.dataset.parallax === "true" || this.classList.contains('scroll-animate-active');
      if (this.#active) {
        this.#init();
      }
    }

    disconnectedCallback() {
      this.#destroy();
    }

    #init = () => {
      this.#intersectionObserver = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            window.addEventListener("scroll", this.#onScroll, { passive: true });
            this.#update();
          } else {
            window.removeEventListener("scroll", this.#onScroll);
          }
        },
        { rootMargin: "20% 0% 20% 0%" } // Pre-load or keep alive around viewport
      );
      this.#intersectionObserver.observe(this);
      
      // Add a class to the parent section for CSS targeting
      const section = this.closest('.shopify-section') || this.parentElement;
      section.classList.add("scroll-animated-section--active");
      this.classList.add("collage-images--active"); // Keep local hook
    };

    #onScroll = () => {
      if (this.#rafPending) return;
      this.#rafPending = true;
      requestAnimationFrame(() => {
        this.#update();
        this.#rafPending = false;
      });
    };

    #update = () => {
      const rect = this.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const sectionHeight = this.offsetHeight || this.scrollHeight;
      
      // Calculate start point based on threshold (e.g., 0.5 = 50% from bottom)
      const threshold = parseFloat(this.dataset.startThreshold || 0);
      const startPoint = viewportHeight * threshold;
      
      let progress = 0;
      // Effect starts as top of section enters the threshold point
      if (rect.top < startPoint) {
        const distanceRemaining = sectionHeight + startPoint;
        progress = Math.min(1, Math.max(0, (startPoint - rect.top) / distanceRemaining));
      }

      // Add a boolean class for general scroll triggering
      this.classList.toggle('is-scrolled', progress > 0);

      // Linear scale and opacity from 0 to 1 progress
      const scale = Math.max(0.80, 1 - 0.2 * progress);
      const opacity = this.dataset.disableOpacity === 'true' ? 1 : Math.max(0.2, 1 - 0.8 * progress);

      this.style.setProperty("--scroll-scale", scale.toFixed(3));
      this.style.setProperty("--scroll-opacity", opacity.toFixed(3));
      this.style.setProperty("--scroll-progress", progress.toFixed(3));
    };

    #destroy = () => {
      window.removeEventListener("scroll", this.#onScroll);
      this.#intersectionObserver?.disconnect();
    };
  }
  customElements.define("scroll-animated-section", ScrollAnimatedSection);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collage"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get("collage-cards")) {
  const DESKTOP_QUERY = "(min-width: 990px)";

  class CollageCards extends HTMLElement {
    static SCROLLING_VALUE = 40;

    // Private fields
    #intersectionObserver = null;
    #mediaQuery = null;
    #isInViewport = false;
    #isDesktop = false;
    #scrollHandler = null;
    #rafId = null;
    #hasReachedThreshold = false; // Track if threshold was reached
    #cards = [];
    #resizeObserver = null;
    #heightRafId = null;

    connectedCallback() {
      this.#init();
    }

    disconnectedCallback() {
      this.#cleanup();
    }

    /**
     * Initialize the component
     */
    #init() {
      // Set up media query listener
      this.#mediaQuery = window.matchMedia(DESKTOP_QUERY);
      this.#isDesktop = this.#mediaQuery.matches;
      this.#mediaQuery.addEventListener("change", this.#onMediaChange);
      
      this.#cards = Array.from(this.querySelectorAll('.collage__card-wrapper'));

      // Set up intersection observer
      this.#setupIntersectionObserver();

      // Set up scroll listener
      this.#scrollHandler = this.#onScroll.bind(this);

      // Set up resize observer for max card height
      this.#setupResizeObserver();

      // Initial check
      this.#updateAnimation();
    }

    /**
     * Set up resize observer to track the tallest card
     */
    #setupResizeObserver() {
      this.#resizeObserver = new ResizeObserver(() => {
        if (this.#heightRafId !== null) return;
        this.#heightRafId = requestAnimationFrame(() => {
          this.#heightRafId = null;
          this.#updateMaxCardHeight();
        });
      });

      const cards = this.querySelectorAll('.collage-card');
      cards.forEach((card) => this.#resizeObserver.observe(card));
      this.#resizeObserver.observe(this);

      // Initial measurement
      this.#updateMaxCardHeight();
    }

    /**
     * Find the tallest card and set --max-card-height
     */
    #updateMaxCardHeight() {
      this.style.removeProperty('--max-card-height');
      const cards = this.querySelectorAll('.collage-card');
      let maxHeight = 0;

      cards.forEach((card) => {
        const h = card.offsetHeight;
        if (h > maxHeight) maxHeight = h;
      });

      if (maxHeight > 0) {
        this.style.setProperty('--max-card-height', `${maxHeight}px`);
      }
    }

    /**
     * Clean up all listeners and observers
     */
    #cleanup() {
      if (this.#rafId) {
        cancelAnimationFrame(this.#rafId);
        this.#rafId = null;
      }

      if (this.#heightRafId) {
        cancelAnimationFrame(this.#heightRafId);
        this.#heightRafId = null;
      }

      if (this.#scrollHandler) {
        window.removeEventListener("scroll", this.#scrollHandler, {
          passive: true,
        });
        this.#scrollHandler = null;
      }

      if (this.#intersectionObserver) {
        this.#intersectionObserver.disconnect();
        this.#intersectionObserver = null;
      }

      if (this.#resizeObserver) {
        this.#resizeObserver.disconnect();
        this.#resizeObserver = null;
      }

      if (this.#mediaQuery) {
        this.#mediaQuery.removeEventListener("change", this.#onMediaChange);
        this.#mediaQuery = null;
      }

      this.style.removeProperty("--scroll-progress");
      this.style.removeProperty("--max-card-height");
    }

    /**
     * Set up intersection observer
     */
    #setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      };

      this.#intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.#isInViewport = entry.isIntersecting;
          this.#updateAnimation();
        });
      }, options);

      this.#intersectionObserver.observe(this);
    }

    /**
     * Handle media query changes
     */
    #onMediaChange = (event) => {
      this.#isDesktop = event.matches;
      this.#updateAnimation();
    };

    /**
     * Update animation state
     */
    #updateAnimation() {
      // Animate on both desktop AND mobile
      const shouldAnimate = this.#isInViewport;

      if (shouldAnimate) {
        this.classList.add("is-scrolling");
        window.addEventListener("scroll", this.#scrollHandler, {
          passive: true,
        });
        this.#onScroll();
      } else {
        this.classList.remove("is-scrolling");
        window.removeEventListener("scroll", this.#scrollHandler, {
          passive: true,
        });
        this.style.removeProperty("--scroll-progress");
      }
    }

    /**
     * Handle scroll with RAF
     */
    #onScroll() {
      if (this.#rafId) {
        cancelAnimationFrame(this.#rafId);
      }

      this.#rafId = requestAnimationFrame(() => {
        this.#calculateScrollProgress();
        this.#rafId = null;
      });
    }

    /**
     * Calculate scroll progress and set CSS custom property
     */
    #calculateScrollProgress() {
      const rect = this.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Calculate scroll progress (0 to 1)
      const elementHeight = rect.height;
      const scrollStart = viewportHeight;
      const scrollEnd = -elementHeight;
      const scrollDistance = scrollStart - scrollEnd;
      const currentScroll = rect.top - scrollEnd;
      const scrollProgress = Math.max(
        0,
        Math.min(1, 1 - currentScroll / scrollDistance),
      );

      // Set CSS custom property
      this.style.setProperty("--scroll-progress", scrollProgress);

      // Add class once threshold is reached (never remove it)
      if (!this.#hasReachedThreshold) {
        const threshold = CollageCards.SCROLLING_VALUE / 100; // Convert 25 to 0.25

        if (scrollProgress >= threshold) {
          this.#hasReachedThreshold = true;
        }
      }

      // Per-card: update rotation progress for both mobile and desktop
      if (this.#cards.length > 0) {
        const thresholdY = viewportHeight * 0.4;
        const startY = viewportHeight;

        for (let i = 0; i < this.#cards.length; i++) {
          const card = this.#cards[i];
          const cardTop = card.getBoundingClientRect().top;
          let progress = 0;

          if (cardTop <= thresholdY) {
            progress = 1;
          } else if (cardTop < startY) {
            progress = 1 - (cardTop - thresholdY) / (startY - thresholdY);
          }

          card.style.setProperty("--card-progress", progress.toFixed(3));
        }
      }
    }
  }

  customElements.define("collage-cards", CollageCards);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get("comparison-table")) {
  const MOBILE_QUERY = "(max-width: 989px)";

  class ComparisonTable extends HTMLElement {
    /** Swipe distance threshold in pixels */
    static SWIPE_THRESHOLD = 50;

    /** Fade animation duration in ms — must match the CSS transition duration */
    static FADE_DURATION = 200;

    /** @type {HTMLTableElement | null} */
    #table = null;

    /** @type {NodeListOf<Element> | null} */
    #bullets = null;

    /** @type {AbortController | null} */
    #controller = null;

    /** @type {AbortController | null} */
    #swipeController = null;

    /** @type {AbortController | null} */
    #swipeBtn = null;

    /** @type {MediaQueryList | null} */
    #mql = null;

    /** @type {number} */
    #activeSlide = 0;

    /** @type {number} */
    #startX = 0;

    /** @type {boolean} */
    #isAnimating = false;

    connectedCallback() {
      this.#table = this.querySelector("table");
      this.#bullets = this.querySelectorAll(".comparison-table__bullet");
      this.#swipeBtn = this.querySelector("[data-component='swipe-btn']");
      this.#controller = new AbortController();

      const { signal } = this.#controller;

      this.dataset.activeSlide = "0";

      // Bullet click handlers
      this.#bullets.forEach((bullet, index) => {
        bullet.addEventListener(
          "click",
          () => this.#goToSlide(index),
          { signal },
        );
      });

      // Listen for viewport changes to bind/unbind swipe
      this.#mql = window.matchMedia(MOBILE_QUERY);
      this.#mql.addEventListener("change", this.#onBreakpointChange, { signal });

      // Initial check
      if (this.#mql.matches) {
        this.#bindSwipe();
      }
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
      this.#swipeController?.abort();
      this.#swipeController = null;
      this.#mql = null;
      this.#table = null;
      this.#bullets = null;
    }

    /**
     * Called when viewport crosses the 990px breakpoint.
     */
    #onBreakpointChange = (e) => {
      if (e.matches) {
        this.#bindSwipe();
      } else {
        this.#unbindSwipe();
      }
    };

    /**
     * Attach touch + mouse swipe listeners to the table.
     */
    #bindSwipe() {
      if (!this.#table || this.#swipeController) return;

      this.#swipeController = new AbortController();
      const { signal } = this.#swipeController;

      // Touch swipe (passive — won't block scrolling)
      this.#table.addEventListener("touchstart", this.#onSwipeStart, {
        signal,
        passive: true,
      });
      this.#table.addEventListener("touchend", this.#onTouchEnd, {
        signal,
        passive: true,
      });

      // Mouse drag swipe
      this.#table.addEventListener("mousedown", this.#onSwipeStart, { signal });
      this.#table.addEventListener("mouseup", this.#onMouseEnd, { signal });
    }

    /**
     * Remove swipe listeners by aborting the swipe controller.
     */
    #unbindSwipe() {
      this.#swipeController?.abort();
      this.#swipeController = null;
    }

    /**
     * Navigate to a slide with a fade transition.
     * Skips if already on that slide or an animation is in flight.
     * @param {number} index — target slide index
     */
    async #goToSlide(index) {
      if (
        index === this.#activeSlide ||
        this.#isAnimating ||
        index < 0 ||
        !this.#bullets ||
        index >= this.#bullets.length
      ) {
        return;
      }

      this.#isAnimating = true;

      // Phase 1 — fade out
      this.dataset.transitioning = "";
      await this.#transitionDelay();

      // Phase 2 — swap the active slide
      this.#activeSlide = index;
      this.dataset.activeSlide = String(index);

      this.#bullets.forEach((bullet, i) => {
        bullet.classList.toggle("active", i === index);
      });

      // Phase 3 — fade in
      delete this.dataset.transitioning;
      await this.#transitionDelay();

      this.#isAnimating = false;

      if (this.#swipeBtn) {
        if (this.#activeSlide === this.#bullets.length - 1) {
          // Last slide — remove reverse class
          this.#swipeBtn.classList.remove("reverse");
        } else {
          // Not last slide — add reverse class
          this.#swipeBtn.classList.add("reverse");
        }
      }
    }

    /**
     * Returns a promise that resolves after the CSS fade duration.
     * @returns {Promise<void>}
     */
    #transitionDelay() {
      return new Promise((resolve) =>
        setTimeout(resolve, ComparisonTable.FADE_DURATION),
      );
    }

    /* ------------------------------------------------------------------ */
    /*  Swipe handling                                                     */
    /* ------------------------------------------------------------------ */

    /**
     * Capture the starting X coordinate from either touch or mouse event.
     * @param {TouchEvent | MouseEvent} e
     */
    #onSwipeStart = (e) => {
      this.#startX =
        "changedTouches" in e ? e.changedTouches[0].screenX : e.screenX;
    };

    /**
     * Handle touch end — extract X from changedTouches.
     * @param {TouchEvent} e
     */
    #onTouchEnd = (e) => {
      this.#resolveSwipe(e.changedTouches[0].screenX);
    };

    /**
     * Handle mouse up — extract X from the event directly.
     * @param {MouseEvent} e
     */
    #onMouseEnd = (e) => {
      this.#resolveSwipe(e.screenX);
    };

    /**
     * Compare startX with endX and navigate if the gesture exceeds the threshold.
     * @param {number} endX
     */
    #resolveSwipe(endX) {
      const diff = this.#startX - endX;
      if (Math.abs(diff) < ComparisonTable.SWIPE_THRESHOLD) return;

      // Positive diff = swipe left → next,  Negative diff = swipe right → prev
      this.#goToSlide(this.#activeSlide + (diff > 0 ? 1 : -1));
    }
  }

  customElements.define("comparison-table", ComparisonTable);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-sim-table"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get("comparison-table")) {
  const MOBILE_QUERY = "(max-width: 989px)";

  class ComparisonTable extends HTMLElement {
    static SWIPE_THRESHOLD = 50;
    static FADE_DURATION = 200;

    #table = null;
    #bullets = null;
    #controller = null;
    #swipeController = null;
    #swipeBtn = null;
    #mql = null;
    #activeSlide = 0;
    #startX = 0;
    #isAnimating = false;

    connectedCallback() {
      this.#table = this.querySelector("table");
      this.#bullets = this.querySelectorAll(".comparison-table__bullet");
      this.#swipeBtn = this.querySelector("[data-component='swipe-btn']");
      this.#controller = new AbortController();

      const { signal } = this.#controller;

      this.dataset.activeSlide = "0";

      this.#bullets.forEach((bullet, index) => {
        bullet.addEventListener(
          "click",
          () => this.#goToSlide(index),
          { signal },
        );
      });

      this.#mql = window.matchMedia(MOBILE_QUERY);
      this.#mql.addEventListener("change", this.#onBreakpointChange, { signal });

      if (this.#mql.matches) {
        this.#bindSwipe();
      }
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
      this.#swipeController?.abort();
      this.#swipeController = null;
      this.#mql = null;
      this.#table = null;
      this.#bullets = null;
    }

    #onBreakpointChange = (e) => {
      if (e.matches) {
        this.#bindSwipe();
      } else {
        this.#unbindSwipe();
      }
    };

    #bindSwipe() {
      if (!this.#table || this.#swipeController) return;

      this.#swipeController = new AbortController();
      const { signal } = this.#swipeController;

      this.#table.addEventListener("touchstart", this.#onSwipeStart, {
        signal,
        passive: true,
      });
      this.#table.addEventListener("touchend", this.#onTouchEnd, {
        signal,
        passive: true,
      });

      this.#table.addEventListener("mousedown", this.#onSwipeStart, { signal });
      this.#table.addEventListener("mouseup", this.#onMouseEnd, { signal });
    }

    #unbindSwipe() {
      this.#swipeController?.abort();
      this.#swipeController = null;
    }

    async #goToSlide(index) {
      if (
        index === this.#activeSlide ||
        this.#isAnimating ||
        index < 0 ||
        !this.#bullets ||
        index >= this.#bullets.length
      ) {
        return;
      }

      this.#isAnimating = true;
      this.dataset.transitioning = "";
      await this.#transitionDelay();

      this.#activeSlide = index;
      this.dataset.activeSlide = String(index);

      this.#bullets.forEach((bullet, i) => {
        bullet.classList.toggle("active", i === index);
      });

      delete this.dataset.transitioning;
      await this.#transitionDelay();

      this.#isAnimating = false;

      if (this.#swipeBtn) {
        if (this.#activeSlide === this.#bullets.length - 1) {
          this.#swipeBtn.classList.remove("reverse");
        } else {
          this.#swipeBtn.classList.add("reverse");
        }
      }
    }

    #transitionDelay() {
      return new Promise((resolve) =>
        setTimeout(resolve, ComparisonTable.FADE_DURATION),
      );
    }

    #onSwipeStart = (e) => {
      this.#startX =
        "changedTouches" in e ? e.changedTouches[0].screenX : e.screenX;
    };

    #onTouchEnd = (e) => {
      this.#resolveSwipe(e.changedTouches[0].screenX);
    };

    #onMouseEnd = (e) => {
      this.#resolveSwipe(e.screenX);
    };

    #resolveSwipe(endX) {
      const diff = this.#startX - endX;
      if (Math.abs(diff) < ComparisonTable.SWIPE_THRESHOLD) return;
      this.#goToSlide(this.#activeSlide + (diff > 0 ? 1 : -1));
    }
  }

  customElements.define("comparison-table", ComparisonTable);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-sim"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get("feature-sim-cards")) {
  const DESKTOP_QUERY = "(min-width: 990px)";

  class FeatureSimCards extends HTMLElement {
    static SPACE_BETWEEN = 12;

    /** @type {any} */
    #swiper = null;

    /** @type {HTMLElement[]} */
    #slides = [];

    /** @type {HTMLElement | null} */
    #pagination = null;

    /** @type {MediaQueryList | null} */
    #mql = null;

    connectedCallback() {
      this.#onInit();
    }

    disconnectedCallback() {
      this.#destroySlider();
      if (this.#mql) {
        this.#mql.removeEventListener("change", this.#handleResize);
      }
    }

    #setupElements = () => {
      this.#slides = Array.from(
        this.querySelectorAll('[data-component="slide"]'),
      );
      this.#pagination = this.querySelector('[data-component="pagination"]');
    };

    #onInit = () => {
      this.#setupElements();

      this.#mql = window.matchMedia(DESKTOP_QUERY);
      this.#mql.addEventListener("change", this.#handleResize);

      // Initial check
      this.#handleResize(this.#mql);
    };

    /** @param {MediaQueryListEvent | MediaQueryList} e */
    #handleResize = (e) => {
      if (e.matches) {
        this.#destroySlider();
      } else {
        this.#initSlider();
      }
    };

    #initSlider = () => {
      if (this.#swiper) return;

      this.classList.add("swiper");

      /** @type {HTMLElement | null} */
      let wrapper = this.querySelector(".swiper-wrapper");
      if (!wrapper) {
        wrapper = document.createElement("div");
        wrapper.className = "swiper-wrapper";

        const firstSlide = this.#slides[0];
        if (firstSlide) {
          this.insertBefore(wrapper, firstSlide);
          this.#slides.forEach((slide) => {
            slide.classList.add("swiper-slide");
            // @ts-ignore
            wrapper.appendChild(slide);
          });
        }
      }

      // @ts-ignore
      this.#swiper = new Swiper(this, {
        initialSlide: this.#slides.length >= 3 ? 1 : 0,
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: FeatureSimCards.SPACE_BETWEEN,
        pagination: {
          el: this.#pagination,
          clickable: true,
        },
        breakpoints: {
          750: {
            slidesPerView: 1.8,
          },
        },
      });
    };

    #destroySlider = () => {
      if (this.#swiper) {
        this.#swiper.destroy(true, true);
        this.#swiper = null;
      }

      this.classList.remove("swiper");

      const wrapper = this.querySelector(".swiper-wrapper");
      if (wrapper) {
        this.#slides.forEach((slide) => {
          slide.classList.remove("swiper-slide");
          // Re-insert slides before the wrapper to restore native DOM order
          this.insertBefore(slide, wrapper);
        });
        wrapper.remove(); // Clean up the wrapper
      }
    };
  }

  customElements.define("feature-sim-cards", FeatureSimCards);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get("featured-banner")) {
  class FeaturedBanner extends HTMLElement {
    /** @type {Boolean} */
    #parallax = false;
    /** @type {Number} */
    #sectionHeight = 0;
    /** @type {Number} */
    #scrollProgress = 0;
    /** @type {Number} */
    #scrollProgressPx = 0;
    /** @type {HTMLElement | null} */
    #wrapper = null;
    /** @type {HTMLElement | null} */
    #parallaxContainer = null;
    /** @type {ResizeObserver | null} */
    #resizeObserver = null;
    /** @type {IntersectionObserver | null} */
    #intersectionObserver = null;
    /** @type {Boolean} */
    #rafPending = false;
    /** @type {HTMLElement | null} */
    #content = null;

    connectedCallback() {
      this.#onInit();
    }

    disconnectedCallback() {
      this.#destroy();
    }

    #onInit = () => {
      this.#parallax = this.dataset.parallax === "true";
      this.#setupElements();
      if (this.#parallax) {
        this.#addParallax();
      }
    };

    #setupElements = () => {
      this.#wrapper = this.querySelector('[data-component="wrapper"]');
      this.#parallaxContainer = this.querySelector(
        '[data-component="parallax-container"]',
      );
      this.#content = this.querySelector(".featured-banner__content-wrapper");
    };

    #addParallax = () => {
      if (!this.#wrapper) {
        console.error("Element was not found: ", this.#wrapper);
        return;
      }

      this.#onResize();
      
      this.#resizeObserver = new ResizeObserver(() => {
        this.#onResize();
      });
      this.#resizeObserver.observe(this.#wrapper);

      // Listen to scroll when section crosses viewport
      this.#intersectionObserver = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            window.addEventListener("scroll", this.#onScroll, {
              passive: true,
            });
            this.#updateProgress(); // Initial check
          } else {
            window.removeEventListener("scroll", this.#onScroll);
            this.#updateProgress(); // Snap to boundary
          }
        },
        { rootMargin: "0px 0px 0px 0px" },
      );

      this.#intersectionObserver.observe(this);
    };

    #onResize = () => {
      if (this.#wrapper) {
        // Temporarily reset variable to measure intrinsic height of the content
        this.style.setProperty("--section-height", "auto");
        this.#sectionHeight = this.#wrapper.offsetHeight;
        this.style.setProperty("--section-height", `${this.#sectionHeight}px`);
        this.#updateProgress();
      }
    };

    #onScroll = () => {
      // Throttle via rAF — only one update per frame
      if (this.#rafPending) return;
      this.#rafPending = true;

      requestAnimationFrame(() => {
        this.#rafPending = false;
        this.#updateProgress();
      });
    };

    #updateProgress = () => {
      const top = this.getBoundingClientRect().top;

      let progress = 0;

      if (top < 0) {
        const progressPx = Math.min(Math.abs(top), this.#sectionHeight);
        progress = progressPx / this.#sectionHeight;
      }

      let scale = 1;
      let opacity = 1;

      // Handle scale and opacity with progress clamping
      const ratio = (progress - 0.2) / 0.75;
      scale = Math.min(1, Math.max(0.80, 1 - 0.2 * ratio)); // Clamp scale between 0.80 and 1
      opacity = Math.min(1, Math.max(0.2, 1 - 0.8 * ratio)); // Clamp opacity between 0.2 and 1

      // Hardware-accelerated variable updates
      this.style.setProperty("--hero-scale", scale.toFixed(3));
      this.style.setProperty("--hero-opacity", opacity.toFixed(3));
    };

    #destroy = () => {
      window.removeEventListener("scroll", this.#onScroll);
      this.#resizeObserver?.disconnect();
      this.#resizeObserver = null;
      this.#intersectionObserver?.disconnect();
      this.#intersectionObserver = null;
    };
  }

  customElements.define("featured-banner", FeaturedBanner);
}

if (!customElements.get("fb-slider")) {
  class FbSlider extends HTMLElement {
    /** @type {Object | null} */
    #swiper = null;

    /** @type {String | null} */
    #effect = null;

    connectedCallback() {
      this.#onInit();
    }

    disconnectedCallback() {
      this.#destroy();
    }

    #onInit = () => {
      this.#effect = this.dataset.effect || "creative";

      const swiperConfig = {
        effect: this.#effect,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },
      };

      if (this.#effect === "fade") {
        swiperConfig.fadeEffect = { crossFade: true };
      }

      if (this.#effect === "creative") {
        swiperConfig.creativeEffect = {
          prev: {
            shadow: false,
            translate: [0, 0, 0],
            opacity: 0,
            scale: 1,
          },
          next: {
            translate: [0, 0, 0],
            scale: 1,
            opacity: 0,
          },
        };
      }

      // @ts-ignore
      this.#swiper = new Swiper(this, swiperConfig);
    };

    #destroy = () => {
      if (this.#swiper) {
        this.#swiper.destroy(true, true);
        this.#swiper = null;
      }
    };
  }

  customElements.define("fb-slider", FbSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get("hero-banner")) {
  class HeroBanner extends HTMLElement {
    #parallax = false;
    /** @type {Boolean} */
    #parallaxMb = false;
    /** @type {Number} */
    #parallaxDistance = 0;
    /** @type {Number} */
    #parallaxDistanceTb = 0;
    /** @type {Number} */
    #sectionHeight = 0;
    /** @type {Number} */
    #scrollProgress = 0;
    /** @type {Number} */
    #scrollProgressPx = 0;
    /** @type {HTMLElement | null} */
    #wrapper = null;
    /** @type {HTMLElement | null} */
    #parallaxContainer = null;
    /** @type {ResizeObserver | null} */
    #resizeObserver = null;
    /** @type {IntersectionObserver | null} */
    #intersectionObserver = null;
    /** @type {Boolean} */
    #rafPending = false;
    /** @type {HTMLElement | null} */
    #content = null;

    connectedCallback() {
      this.#onInit();
    }

    disconnectedCallback() {
      this.#destroy();
    }

    #onInit = () => {
      this.#parallax = this.dataset.parallax === "true";
      this.#parallaxMb = this.dataset.parallaxMb === "true";
      /** @type {Number} Max px of scroll after which parallax holds its final state (0 = use full section height) */
      this.#parallaxDistance = parseInt(this.dataset.parallaxDistance, 10) || 0;
      this.#parallaxDistanceTb = parseInt(this.dataset.parallaxDistanceTb, 10) || 0;
      this.#setupElements();
      if (this.#parallax) {
        this.#addParallax();
      }
    };

    #setupElements = () => {
      this.#wrapper = this.querySelector('[data-component="wrapper"]');
      this.#parallaxContainer = this.querySelector(
        '[data-component="parallax-container"]',
      );
      this.#content = this.querySelector(".hero-banner__content");
    };

    #addParallax = () => {
      if (!this.#wrapper) {
        console.error("Element was not found: ", this.#wrapper);
        return;
      }

      this.#onResize();
      
      this.#resizeObserver = new ResizeObserver(() => {
        this.#onResize();
      });
      this.#resizeObserver.observe(this.#wrapper);

      // Listen to scroll when section crosses viewport
      this.#intersectionObserver = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            window.addEventListener("scroll", this.#onScroll, {
              passive: true,
            });
            this.#updateProgress(); // Initial check
          } else {
            window.removeEventListener("scroll", this.#onScroll);
            this.#updateProgress(); // Snap to boundary
          }
        },
        { rootMargin: "0px 0px 0px 0px" },
      );

      this.#intersectionObserver.observe(this);
    };

    #onResize = () => {
      if (this.#wrapper) {
        // Temporarily reset variable to measure intrinsic height of the content
        this.style.setProperty("--section-height", "auto");
        this.#sectionHeight = this.#wrapper.offsetHeight;
        this.style.setProperty("--section-height", `${this.#sectionHeight}px`);
        this.#updateProgress();
      }
    };

    #onScroll = () => {
      // Throttle via rAF — only one update per frame
      if (this.#rafPending) return;
      this.#rafPending = true;

      requestAnimationFrame(() => {
        this.#rafPending = false;
        this.#updateProgress();
      });
    };

    #updateProgress = () => {
      const isMobile = window.innerWidth < 750;
      if (isMobile && !this.#parallaxMb) {
        this.style.removeProperty("--hero-scale");
        this.style.removeProperty("--hero-opacity");
        this.style.removeProperty("--bg-scale");
        return;
      }

      const top = this.getBoundingClientRect().top;

      let progress = 0;

      if (top < 0) {
        // Use configured distance cap per breakpoint; fall back to full section height
        const isDesktop = window.innerWidth >= 990;
        const isTablet = window.innerWidth >= 750 && window.innerWidth < 990;
        const effectiveDistance =
          isDesktop && this.#parallaxDistance > 0
            ? this.#parallaxDistance
            : isTablet && this.#parallaxDistanceTb > 0
            ? this.#parallaxDistanceTb
            : this.#sectionHeight;

        const progressPx = Math.min(Math.abs(top), effectiveDistance);
        progress = progressPx / effectiveDistance;
      }

      let scale = 1;
      let opacity = 1;

      // Handle scale and opacity with progress clamping
      const ratio = (progress - 0.05) / 0.90;
      scale = Math.min(1, Math.max(0.80, 1 - 0.2 * ratio)); // Clamp scale between 0.80 and 1
      opacity = Math.min(1, Math.max(0.2, 1 - 0.8 * ratio)); // Clamp opacity between 0.2 and 1

      // Background scaling down from 1.1 to 1
      const bgScale = Math.max(1, 1.1 - 0.1 * ratio);

      // Hardware-accelerated variable updates
      this.style.setProperty("--hero-scale", scale.toFixed(3));
      this.style.setProperty("--hero-opacity", opacity.toFixed(3));
      this.style.setProperty("--bg-scale", bgScale.toFixed(4));
    };

    #destroy = () => {
      window.removeEventListener("scroll", this.#onScroll);
      this.#resizeObserver?.disconnect();
      this.#resizeObserver = null;
      this.#intersectionObserver?.disconnect();
      this.#intersectionObserver = null;
    };
  }

  customElements.define("hero-banner", HeroBanner);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-esim"]) return;
  try {
    
if (!customElements.get("product-esim-slider")) {
  const DESKTOP_BREAKPOINT = 1200;

  class ProductEsimSlider extends HTMLElement {
    /** @type {Number} */
    #slidesPerView = 1;

    /** @type {Number} */
    #slidesPerViewTb = 1.5;

    /** @type {Number} */
    #slidesPerViewPc = 1.8;

    /** @type {Number} */
    #spaceBetween = 16;

    /** @type {Number} */
    #spaceBetweenTb = 32;

    /** @type {HTMLElement[]} */
    #originalCards = [];

    /** @type {HTMLElement | null} */
    #pagination = null;

    /** @type {any} */
    #swiper = null;

    /** @type {MediaQueryList | null} */
    #desktopMatchMedia = null;

    /** @type {MediaQueryList | null} */
    #mobileMatchMedia = null;

    connectedCallback() {
      this.#onInit();
    }

    disconnectedCallback() {
      if (this.#desktopMatchMedia) {
        this.#desktopMatchMedia.removeEventListener(
          "change",
          this.#handleDesktopChange,
        );
      }
      if (this.#mobileMatchMedia) {
        this.#mobileMatchMedia.removeEventListener(
          "change",
          this.#handleMobileChange,
        );
      }
      this.#destroy();
    }

    #onInit = () => {
      this.#slidesPerView = Number(this.dataset.slidesPerView) || 1;
      this.#slidesPerViewTb = Number(this.dataset.slidesPerViewTb) || 1.5;
      this.#slidesPerViewPc = Number(this.dataset.slidesPerViewPc) || 1.8;

      this.#spaceBetween = Number(this.dataset.spaceBetween) || 16;
      this.#spaceBetweenTb = Number(this.dataset.spaceBetweenTb) || 32;

      this.#setupElements();

      this.#desktopMatchMedia = window.matchMedia(
        `(min-width: ${DESKTOP_BREAKPOINT}px)`,
      );
      this.#desktopMatchMedia.addEventListener(
        "change",
        this.#handleDesktopChange,
      );

      this.#mobileMatchMedia = window.matchMedia(`(min-width: 750px)`);
      this.#mobileMatchMedia.addEventListener(
        "change",
        this.#handleMobileChange,
      );

      // Initial check
      this.#handleDesktopChange(this.#desktopMatchMedia);
    };

    #setupElements = () => {
      const cards = this.querySelectorAll('[data-component="card"]');
      this.#originalCards = /** @type {HTMLElement[]} */ (Array.from(cards));
      this.#pagination =
        this.querySelector('[data-component="pagination"]') ||
        this.querySelector(".swiper-pagination");
    };

    /** @param {MediaQueryListEvent | MediaQueryList} e */
    #handleDesktopChange = (e) => {
      if (e.matches) {
        this.#destroy();
      } else {
        this.#destroy();
        this.#initSwiper();
      }
    };

    /** @param {MediaQueryListEvent | MediaQueryList} e */
    #handleMobileChange = (e) => {
      if (this.#desktopMatchMedia && !this.#desktopMatchMedia.matches) {
        this.#destroy();
        this.#initSwiper();
      }
    };

    /**
     * Apply reverse class to slides swipe btn
     * @param {HTMLElement[]} slides - Array of slide elements
     */
    #applyReverseClass = (slides) => {
      slides.forEach((slide, index) => {
        const swipeBtn = slide.querySelector('[data-component="swipe-btn"]')
        if (!swipeBtn) return;
        if (index === 0) {
          swipeBtn.classList.remove("reverse");
        } else {
          swipeBtn.classList.add("reverse");
        }
      });
    };

    #initSwiper = () => {
      if (this.#swiper) return;
      const SwiperClass = /** @type {any} */ (window).Swiper;
      if (typeof SwiperClass !== "function") {
        console.warn("window.Swiper is not loaded.");
        return;
      }

      this.classList.add("swiper");

      const wrapper = document.createElement("div");
      wrapper.className = "swiper-wrapper";

      const isMobile = window.innerWidth < 750;
      let orderedCards = [...this.#originalCards];

      const featuredCardIndex = orderedCards.findIndex(
        (c) => c.dataset.featured === "true",
      );
      if (featuredCardIndex !== -1) {
        const featuredCard = orderedCards.splice(featuredCardIndex, 1)[0];
        if (featuredCard) {
          if (isMobile) {
            orderedCards.unshift(featuredCard);
          } else {
            if (orderedCards.length >= 1) {
              orderedCards.splice(1, 0, featuredCard);
            } else {
              orderedCards.push(featuredCard);
            }
          }
        }
      }

      orderedCards.forEach((card) => {
        if (card) {
          card.classList.add("swiper-slide");
          wrapper.appendChild(card);
        }
      });

      this.#applyReverseClass(orderedCards);

      const paginationWrapper = this.querySelector(
        ".product-esim__pagination-wrapper",
      );
      if (paginationWrapper) {
        this.insertBefore(wrapper, paginationWrapper);
      } else {
        this.appendChild(wrapper);
      }

      this.#swiper = new SwiperClass(this, {
        centeredSlides: true,
        slidesPerView: this.#slidesPerView,
        spaceBetween: this.#spaceBetween,
        autoHeight: true,
        breakpoints: {
          750: {
            slidesPerView: this.#slidesPerViewTb,
            spaceBetween: this.#spaceBetweenTb,
            initialSlide: 1,
          },
          990: {
            slidesPerView: this.#slidesPerViewPc,
            spaceBetween: this.#spaceBetweenTb,
            initialSlide: 1,
          },
        },
        pagination: {
          el: this.#pagination,
          clickable: true,
        },
      });
    };

    #destroy = () => {
      if (this.#swiper !== null) {
        this.#swiper.destroy(true, true);
        this.#swiper = null;

        this.classList.remove("swiper");

        const wrapper = this.querySelector(".swiper-wrapper");
        const paginationWrapper = this.querySelector(
          ".product-esim__pagination-wrapper",
        );

        if (wrapper) {
          this.#originalCards.forEach((card) => {
            card.classList.remove("swiper-slide");
            if (paginationWrapper) {
              this.insertBefore(card, paginationWrapper);
            } else {
              this.appendChild(card);
            }
          });
          wrapper.remove();
        }
      }
    };
  }

  customElements.define("product-esim-slider", ProductEsimSlider);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-steps"] && !Shopify.designMode) return;
  try {
    
/**
 * QuickSteps — scroll-driven card fan-out animation.
 *
 * Works only on desktop (≥990 px). Uses IntersectionObserver to know when
 * the section is visible and a rAF-throttled scroll listener to calculate
 * how far the section centre has moved into the viewport. Once the section
 * centre crosses 55% of the viewport height the `is-animated` class is
 * added, triggering the CSS transitions that fan the cards out and slide
 * the media wrapper in from the right.
 */
class QuickSteps extends HTMLElement {
  /** @type {IntersectionObserver|null} */
  #io = null;
  /** @type {number|null} */
  #raf = null;
  /** @type {boolean} */
  #animated = false;
  /** @type {boolean} */
  #visible = false;

  connectedCallback() {
    // Only animate on desktop
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    this.#io = new IntersectionObserver(
      ([entry]) => {
        this.#visible = entry.isIntersecting;
        if (this.#visible && !this.#animated) {
          this.#startScrollWatch();
        } else if (!this.#visible) {
          this.#stopScrollWatch();
        }
      },
      { threshold: 0 }
    );

    this.#io.observe(this);
  }

  disconnectedCallback() {
    this.#io?.disconnect();
    this.#stopScrollWatch();
  }

  #startScrollWatch() {
    document.addEventListener('scroll', this.#onScroll, { passive: true });
    // Run immediately so if the section is already in position it fires
    this.#checkProgress();
  }

  #stopScrollWatch() {
    document.removeEventListener('scroll', this.#onScroll);
    if (this.#raf !== null) {
      cancelAnimationFrame(this.#raf);
      this.#raf = null;
    }
  }

  #onScroll = () => {
    if (this.#raf !== null) return;
    this.#raf = requestAnimationFrame(() => {
      this.#raf = null;
      this.#checkProgress();
    });
  };

  /**
   * Triggers the animation when the section centre has passed 55 % of the
   * viewport height (i.e. is roughly in the middle of the screen).
   */
  #checkProgress() {
    if (this.#animated) return;

    const rect = this.getBoundingClientRect();
    const sectionCentre = rect.top + rect.height / 2;
    const triggerPoint = window.innerHeight * 0.55;

    if (sectionCentre <= triggerPoint) {
      this.#animate();
    }
  }

  #animate() {
    this.#animated = true;
    this.classList.add('is-animated');
    this.#stopScrollWatch();
    this.#io?.disconnect();
  }
}

if (!customElements.get('quick-steps')) {
  customElements.define('quick-steps', QuickSteps);
}

  } catch(e) { console.error(e); }
})();
})();
